<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-10 15:51:18
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 13:41:35
-->
<template>
  <div class="innovative innovative-accuffrct" :class="{textj: language != 'en'}" ref="accuffrct">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accuffrct.title')"></div>
    </div>
    <div class="p-t-60 overhid">
      <div class="innovative-container">
        <div class="innovative-wrap-item flex p-b-150" :class="{align_items_center: language != 'en'}">
          <div class="flex_1">
            <img class="" :src="$t('product.accuffrct.list[0].img')" alt="" srcset="">
          </div>
          <div class="flex_1 p-l-80">
            <div class="innovative-item-title" v-html="$t('product.accuffrct.list[0].title')"></div>
            <div class="p-t-15 textj">
              <p :class="{'p-b-30': index < $t('product.accuffrct.list[0].des').length - 1 && language != 'en'}" v-for="item, index in $t('product.accuffrct.list[0].des')" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="innovative-wrap-item p-t-0 posrel accuffrct-characteristics">
        <img class="wh100" :src="$t('product.accuffrct.list[1].img')" alt="" srcset="">
        <div class="posabs t-0 wh100 innovative-container p-t-50 p-b-50">
          <div class="innovative-characteristics trans-list wh100 flex flex_col">
            <div class="innovative-item-title p-l-15" v-html="$t('product.accuffrct.list[1].title')"></div>
            <div class="flex_1 flex flex_col justify_content_center">
              <div class="flex p-t-30">
                <div :class="['flex_1 flex flex_col align_items_center']" v-for="item, index in $t('product.accuffrct.list[1].des')" :key="index" :style="language == 'en' ? 'padding: 0 7%' : (index == 0 ? 'padding-right: 5%;' : '')">
                  <div :class="['flex flex_col align_items_center', index == 1 ? 'p-r-40' : '']">
                    <div>
                      <img class="" :src="item.img" alt="" srcset="">
                    </div>
                    <template v-if="language == 'en'">
                      <div v-if="clientWidth <= 1600 || clientWidth >= 2370" class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15" v-html="item.title.join(' ')"></div>
                      <div v-else class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15">
                        <p v-for="$item, $index in item.title" :key="$index" v-html="$item"></p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15">
                        <p v-for="$item, $index in item.title" :key="$index" v-html="$item"></p>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div :class="['flex_1 flex flex_col align_items_center']" v-for="item, index in $t('product.accuffrct.list[1].des')" :key="index" :style="language == 'en' ? 'padding: 0 7%' : 'padding: 0 8%;'">
                  <div>
                    <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="accuffrct-advantages innovative-wrap-item">
        <div class="innovative-container">
          <div class="innovative-accuffrct-m-h innovative-characteristics trans-list">
            <div class="innovative-item-title p-l-15" style="" v-html="$t('product.accuffrct.list[2].title')"></div>
            <el-row :gutter="language == 'en' ? 10 : 90" class="flex flex_wrap p-t-40">
              <el-col :span="12" class="flex innovative-accuffrct-m-h-item" :class="language == 'en' && index % 2 == 1 ? 'p-l-30' : ''"  v-for="item, index in $t('product.accuffrct.list[2].des')" :key="index">
                <div class="innovative-accuffrct-m-h-img textc">
                  <img :src="item.img" alt="" srcset="" />
                </div>
                <div class="flex_1" :class="language == 'en' ? 'p-l-40' : 'p-l-50'">
                  <div class="innovative-wrap-item-title fz-24 p-l-16 p-b-28" v-html="item.title"></div>
                  <div class="">
                    <p class="innovative-characteristics-item p-b-15" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="innovative-container">
        <div class="innovative-wrap-item p-t-50 article">
          <div class="innovative-item-title p-l-15" v-html="$t('product.accuffrct.article.title')"></div>
          <div class="p-t-15">
            <p class="p-t-15" v-for="item, index in $t('product.accuffrct.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['language', 'clientWidth'])
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
</style>

<style lang="less" scoped>
.pc .innovative-accuffrct {
  padding-bottom: 50PX;
  .innovative-characteristics {
    padding: 50PX 65PX;
  }
  .accuffrct-advantages {
    background: #F8FBFF;
    padding: 50PX 0;
  }
  .innovative-accuffrct-m-h {
    background: #FFFFFF;
    box-shadow: 0PX 4PX 12PX 4PX rgba(81, 170, 255, 0.1);
    padding: 55PX 62PX 0 62PX;
    font-size: 18PX;
    // font-weight: 600;
    .innovative-accuffrct-m-h-item {
      padding: 70PX 40PX;
      &:nth-child(2) {
        padding-bottom: 0;
      }
    }
    .innovative-accuffrct-m-h-img {
      width: 120PX;
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1440PX) {
  .pc .innovative-accuffrct {
    .accuffrct-characteristics {
      height: 520PX;
    }
    .innovative-accuffrct-m-h {
      padding: 35PX 62PX 0 62PX;
      .innovative-accuffrct-m-h-item {
        padding: 20PX 20PX;
      }
      .innovative-accuffrct-m-h-img {
        width: 80PX;
      }
    }
  }
}
</style>
